module.exports = __webpack_public_path__ + "img/shoppingcart.8bf1af37.svg";